import React, { useCallback, useState , useEffect } from 'react'
import Button from '@material-ui/core/Button'
import AddIcon from '@material-ui/icons/Add'

import TableContainer from '@material-ui/core/TableContainer'
import Table from '@material-ui/core/Table'
import makeStyles from '@material-ui/core/styles/makeStyles'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import Paper from '@material-ui/core/Paper'
import { useAxios } from '../../../hooks/useAxios'
import TableBody from '@material-ui/core/TableBody'
import Switch from '@material-ui/core/Switch'

interface Column {
    id: string
    subId?: string
    label: string
    minWidth?: number
    align?: 'right'
    format?: (value: number) => string
}

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
})

export const Schedule = () => {
    const axios = useAxios()
    const classes = useStyles()
    const [data, setData] = useState([])
    const columns: Column[] = [
        { id: 'notificationType', label: 'Type', minWidth: 100 },
        { id: 'interval', label: 'Interval', minWidth: 100 },
        { id: 'executionTime', label: 'Execution Time', minWidth: 100 },
        { id: 'title', label: 'Title', minWidth: 100 },
        { id: 'message', label: 'Message', minWidth: 100 },
        { id: 'isActive', label: 'Is Active', minWidth: 100 },
    ]

    const floatToTime = useCallback((floatNumber) => {
        let hours = Math.floor(floatNumber)
        const minutes = Math.round((floatNumber % 1) * 60)

        const amPm = hours >= 12 ? 'PM' : 'AM'
        hours = hours % 12
        hours = hours ? hours : 12

        const hoursInStr = String(hours).padStart(2, '0')
        const minutesInStr = String(minutes).padStart(2, '0')

        return `${hoursInStr}:${minutesInStr} ${amPm}`
    }, [])

    const formatData = useCallback((response: any) => {
        const cloned = [...response.data]

        cloned.forEach(row => {
            if (row.notificationType == 1) {
                row.notificationType = 'Unregistered'
            }

            if (row.notificationType == 2) {
                row.notificationType = 'Registered - Inactive'
            }

            if (row.notificationType == 3) {
                row.notificationType = 'Registered Active (Trial Incomplete)'
            }

            if (row.notificationType == 4) {
                row.notificationType = 'Registered Active (Trial Complete)'
            }

            if (row.notificationType == 5) {
                row.notificationType = 'Subscribed Reminders'
            }

            if (row.notificationType == 6) {
                row.notificationType = 'Subscribed Re-engage Reminders'
            }

            if (row.notificationType == 7) {
                row.notificationType = 'Subscribed Active Users'
            }

            if (row.notificationType == 8) {
                row.notificationType = 'Streak Breaking Reminders'
            }

            if (row.notificationType == 9) {
                row.notificationType = 'Streak Breaking (Today) Reminders'
            }

            if (row.interval == 0) {
                row.interval = 'Daily'
            }

            if (row.interval == 1) {
                row.interval = 'Weekly'
            }

            if (row.interval == 2) {
                row.interval = '5 Days cycle'
            }

            if (row.isActive) {
                row.isActive = <Switch onChange={(event, checked) => {
                    axios.put('notificationschedules', {
                        id: row.id,
                        isActive: checked
                    })
                }} color="primary" defaultChecked />
            } else {
                row.isActive = <Switch onChange={(event, checked) => {
                    axios.put('notificationschedules', {
                        id: row.id,
                        isActive: checked
                    })
                }} color="primary" />
            }

            row.executionTime = floatToTime(row.executionTime)
        })

        setData(cloned)
    }, [])

    useEffect(() => {
        axios.get('notificationschedules').then(response => {
            formatData(response)
        })
    }, [])

    return <div>
        <Paper className={classes.root}>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column, idx) => (
                                <TableCell
                                    key={`column_${idx + 1}`}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            data.map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                        {columns.map((column, idx) => {
                                            return (
                                                <TableCell key={`column_${idx + 1}`} style={{ whiteSpace: 'pre-line' }}>
                                                    {row[column.id]}
                                                </TableCell>
                                            )
                                        })}
                                    </TableRow>
                                )
                            })
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    </div>
}